export default __webpack_public_path__ + "static/blurred_score-79a46f49421f866238a1f86d6e84074e.png";